import { baseApi } from '../app/baseApi';

export type Task = {
  id: string;
  description: string;
  comments: string;
  status: 'הושלם' | 'בתהליך' | 'pending';
};

export type TransformedTask = {
  id: string;
  name: string;
  details: string;
  completed: boolean;
  comments?: string;
};

export const tasksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query<TransformedTask[], { meetingId: string }>({
      query: ({ meetingId }) => `tasks/getTasks?meeting_id=${meetingId}`,
      transformResponse: (response: Task[]): TransformedTask[] =>
        response.map((item) => ({
          id: item.id,
          name: item.description,
          details: item.comments,
          completed: item.status === 'הושלם',
          comments: item.comments,
        })),
    }),

    getOpenTasksByFamily: builder.query<TransformedTask[], { familyId: string }>({
      query: ({ familyId }) => `tasks/getOpenTasksByFamily?family_id=${familyId}`,
      transformResponse: (response: Task[]): TransformedTask[] =>
        response
      .filter((item) => item.status !== 'הושלם') 
      .map((item) => ({
          id: item.id,
          name: item.description,
          details: item.comments,
          completed: item.status === 'הושלם',
          comments: item.comments,
        })),
      providesTags: ['Task'], 
    }),
getCompletedTasksByFamily: builder.query<TransformedTask[], { familyId: string }>({
  query: ({ familyId }) => `tasks/getTasksByFamilyId?family_id=${familyId}`,
  transformResponse: (response: Task[]): TransformedTask[] =>
    response.map((item) => ({
      id: item.id,
      name: item.description,
      details: item.comments,
      completed: item.status === 'הושלם',
      comments: item.comments,
    })),
  providesTags: ['Task'],
}),


    createTask: builder.mutation<void, {
      meeting_id: string;
      family_id: string;
      description: string;
      comments?: string;
    }>({
      query: (body) => ({
        url: 'tasks/createTask',
        method: 'POST',
        body: {
          ...body,
          status: 'בתהליך',
          original_meeting_id: null,
          completed_at: null,
        },
      }),
      invalidatesTags: ['Task'], 
    }),

    updateTask: builder.mutation<void, {
      id: string;
      meeting_id: string;
      family_id: string;
      description: string;
      comments?: string;
      status: 'הושלם' | 'בתהליך';
    }>({
      query: ({ id, ...body }) => ({
        url: `tasks/updateTask/${id}`,
        method: 'PUT',
        body: {
          ...body,
          original_meeting_id: null,
          completed_at: null,
        },
      }),
      invalidatesTags: ['Task'],
    }),

    deleteTask: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `tasks/deleteTask/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Task'], 
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTasksQuery,
  useGetOpenTasksByFamilyQuery,
  useGetCompletedTasksByFamilyQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useDeleteTaskMutation,
} = tasksApi;
